import React from 'react';

// commponents
import FilterIcon from '@zola/zola-ui/src/components/SvgIcons/Filter';

// styles
import { StyledFacetBtn } from './PLPFacetBtn.styles';

export type PLPFacetBtnProps = {
  handleToggleMobileMenu: () => void;
};

const PLPFacetBtn: React.FC<PLPFacetBtnProps> = ({ handleToggleMobileMenu }) => (
  <StyledFacetBtn variant="primary" data-testid="PLPFacetBtn" onClick={handleToggleMobileMenu}>
    <FilterIcon />
    <span>Filter / Sort</span>
  </StyledFacetBtn>
);

export default PLPFacetBtn;
